/**
 * Early access via email links (?utm_medium=email).
 *
 * Liquid cannot read localStorage, so this script only:
 * 1. Persists ww_early_access in localStorage
 * 2. Mirrors it onto a cart attribute for Liquid (same pattern as brand ambassadors)
 *
 * Buy-button markup is decided server-side in Liquid from cart.attributes.
 */
(function () {
  const STORAGE_KEY = 'ww_early_access';
  const ATTR_KEY = 'ww_early_access';

  function readLocal() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  function writeLocal() {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // Ignore private mode / storage errors
    }
  }

  function fromEmailLink() {
    try {
      return new URLSearchParams(window.location.search).get('utm_medium') === 'email';
    } catch (e) {
      return false;
    }
  }

  async function syncCartAttribute() {
    if (fromEmailLink()) writeLocal();
    if (!readLocal()) return;

    const cartUrl = window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js';
    const updateUrl = window.routes?.cart_update_url || '/cart/update.js';

    let cart;
    try {
      cart = await fetch(cartUrl).then((response) => response.json());
    } catch (e) {
      return;
    }

    if (cart.attributes?.[ATTR_KEY] === 'true') return;

    const attributes = Object.assign({}, cart.attributes || {}, { [ATTR_KEY]: 'true' });

    try {
      await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ attributes }),
      });
    } catch (e) {
      return;
    }

    // This response was rendered before the cart attribute existed — refresh so Liquid shows ATB.
    if (document.querySelector('product-form[data-coming-soon="true"]')) {
      window.location.reload();
    }
  }

  // Defer scripts run after the document (including window.routes) is parsed.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartAttribute);
  } else {
    syncCartAttribute();
  }
})();
